import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const MarketPositionRateSettingCreate = () => (
  <Create
    transform={getTransform(
      ['market_id'],
      'settings',
    )}
  >
    <PositionRateSettingsForm settingsField="settings" />
  </Create>
);

export default MarketPositionRateSettingCreate;
